(function () {
  function captureVue2() {
    // Keep a private Vue 2 reference so the header can still mount even if another
    // app later overwrites the shared window.Vue global with Vue 3.
    if (
      typeof window.Vue === "function" &&
      window.Vue.version &&
      String(window.Vue.version).indexOf("2.") === 0
    ) {
      window.__THEME_VUE2 = window.Vue;
      return true;
    }
    return false;
  }

  function ensureVue2() {
    if (window.__THEME_VUE2) return Promise.resolve(true);
    if (captureVue2()) return Promise.resolve(true);
    // use your own asset if you host Vue locally:
    // var vueSrc = getShopifyLink('vue2.global.prod.js', 'asset');
    var vueSrc = "https://cdn.jsdelivr.net/npm/vue@2/dist/vue.min.js";
    return loadScript(vueSrc).then(function () {
      captureVue2();
      return true;
    });
  }

  function loadHeaderModule() {
    var src = getShopifyLink("header.js", "asset");
    return loadScript(src).then(function () {
      if (window.AppModules && window.AppModules.header) {
        window.AppModules.header.mount();
      }
    });
  }

  function loadVendorModule() {
    var src = getShopifyLink("vendor.js", "asset");
    return loadScript(src);
  }

  document.addEventListener("DOMContentLoaded", function () {
    ensureVue2().then(function () {
      loadHeaderModule();
      loadVendorModule();
    });
  });
})();
